import { INSPECT_RESULT_DATA, INSPECT_RESULT_NOISE_DATA } from "./datas";

// 점수에 따라 결과 값 return
export const getResultTypes = (
  score: number,
  twoFiveScore: number,
  sixSevenScore: number
) => {
  // 🔴 소음 민감도 ID (1~4)
  let sensitivityId = 4;
  if (score >= 40) sensitivityId = 1;
  else if (score >= 31) sensitivityId = 2;
  else if (score >= 21) sensitivityId = 3;

  const sensitivityResult = INSPECT_RESULT_DATA.find(
    (d) => d.id === sensitivityId
  );

  // 🔵 주파수 민감도 ID (1~4)
  const twoFiveAvg = twoFiveScore / 4;
  const sixSevenAvg = sixSevenScore / 2;

  let noiseId = 4;
  if (twoFiveAvg < 1 && sixSevenAvg >= 1) noiseId = 1;
  else if (twoFiveAvg >= 1 && sixSevenAvg < 1) noiseId = 2;
  else if (twoFiveAvg < 1 && sixSevenAvg < 1) noiseId = 3;

  const noiseResult = INSPECT_RESULT_NOISE_DATA.find((d) => d.id === noiseId);

  // ✅ 조합 타입 계산 (1~16)
  const type = (sensitivityId - 1) * 4 + noiseId;

  return {
    resultType: type, // 1 ~ 16
    sensitivityResult, // 소음 민감도 결과
    noiseResult, // 주파수 민감도 결과
  };
};

// result type에 따라 결과 return
export const getResultsFromType = (type: number) => {
  if (type < 1 || type > 16) return null;

  // 🔁 역계산
  const sensitivityId = Math.floor((type - 1) / 4) + 1;
  const noiseId = ((type - 1) % 4) + 1;

  const sensitivityResult = INSPECT_RESULT_DATA.find(
    (d) => d.id === sensitivityId
  );
  const noiseResult = INSPECT_RESULT_NOISE_DATA.find((d) => d.id === noiseId);

  return {
    sensitivityResult,
    noiseResult,
  };
};

export const getResultImageByType = (type: number | string) => {
  const num = Number(type);
  if (num >= 1 && num <= 4) return "/assets/survey_result/result1.png";
  if (num >= 5 && num <= 8) return "/assets/survey_result/result2.png";
  if (num >= 9 && num <= 12) return "/assets/survey_result/result3.png";
  if (num >= 13 && num <= 16) return "/assets/survey_result/result4.png";
  return ""; // fallback (없으면 공백)
};

export const getReultTypeTitle = (type: number | string) => {
  const num = Number(type);
  if (num >= 1 && num <= 4) return "고요한 숲 속의 토끼";
  if (num >= 5 && num <= 8) return "평온한 공원의 고양이";
  if (num >= 9 && num <= 12) return "활기찬 호숫가의 거북이";
  if (num >= 13 && num <= 16) return "드넓은 초원의 물소";
  return ""; // fallback (없으면 공백)
};
